var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/1999/xlink"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 7,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0l100 100M100 0L0 100"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgdmVyc2lvbj0iMS4xIgogIHhtbG5zWGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICA8ZyBpZD0iQ2xvc2UiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjciIGZpbGw9Im5vbmUiPgogICAgPGxpbmUgeDE9IjAiIHgyPSIxMDAiIHkxPSIwIiB5Mj0iMTAwIiAvPgogICAgPGxpbmUgeDE9IjEwMCIgeDI9IjAiIHkxPSIwIiB5Mj0iMTAwIiAvPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgClose as ReactComponent };